import {APIRequest} from "../APIRequest.js";
import {getVPCService, is_localhost} from "../../App/utils";

export const API_URL = getVPCService('app') || 'https://openkbs.app.vpc1.us/';

export const getApp = async (appId, injectedToken) => {
    const token = injectedToken || localStorage.getItem("clientJWT");

    const response = await APIRequest('post', API_URL, {
        token,
        action: 'get',
        appId,
    }, { headers: { 'Content-Type': 'application/json' } });

    return response?.data;
};

export const downloadApp = async (appId) => {
    const token = localStorage.getItem("clientJWT");

    const response = await APIRequest('post', API_URL, {
        token,
        action: 'downloadApp',
        appId,
    }, { headers: { 'Content-Type': 'application/json' } });

    return response?.data;
};

export const likeApp = async (appId) => {
    const token = localStorage.getItem("clientJWT");

    const response = await APIRequest('post', API_URL, {
        token,
        action: 'likeApp',
        appId,
    }, { headers: { 'Content-Type': 'application/json' } });

    return response?.data;
};

export const isLikedApp = async (appId) => {
    const token = localStorage.getItem("clientJWT");

    const response = await APIRequest('post', API_URL, {
        token,
        action: 'isLiked',
        appId,
    }, { headers: { 'Content-Type': 'application/json' } });

    return response?.data;
};

export const unlikeApp = async (appId) => {
    const token = localStorage.getItem("clientJWT");

    const response = await APIRequest('post', API_URL, {
        token,
        action: 'unlikeApp',
        appId,
    }, { headers: { 'Content-Type': 'application/json' } });

    return response?.data;
};


export const listApps = async (orderBy, orderDirection) => {
    const token = localStorage.getItem("clientJWT");

    const data = {
        params: {
            action: 'list',
            token: token,
            orderBy,
            orderDirection
        }
    };

    if (is_localhost) {
        data.params.disableFilterActive = true
    }

    const response = await APIRequest('get', API_URL, data);

    // setAPICache(response?.data, `listApps-${orderBy}-${orderDirection}`);

    return response.data;
};

export const getPublishedKBs = async (domain) => {
    try {
        const response = await APIRequest('get', API_URL, {
            params: {
                action: 'getPublishedKBs',
                domain: domain
            }
        });

        return Array.isArray(response?.data) ? response.data : [];
    } catch (error) {
        console.error('Error fetching published KBs:', error);
        return [];
    }
};

export const listPublicAppFiles = async (appId, namespace) => {
    const token = localStorage.getItem("clientJWT");

    const response = await APIRequest('get', API_URL, {
        params: {
            action: 'listPublicAppFiles',
            token: token,
            appId,
            namespace
        }
    });

    return response.data;
};

export const getUserNotifications = async () => {
    const token = localStorage.getItem('clientJWT');

    try {
        const response = await APIRequest('get', API_URL, {
            params: {
                token,
                action: 'getUserNotifications'
            }
        });

        return response.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const resetUnread = async () => {
    const token = localStorage.getItem('clientJWT');

    try {
        await APIRequest('post', API_URL, {
            token,
            action: 'resetUnread'
        });
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};



